




























import Vue from 'vue'
import ToggleArrow from '@/components/ToggleArrow/ToggleArrow.vue'
import CustomSelectOption from './CustomSelectOption.vue'

type Option = string | number | object | null | undefined

interface Data {
  isOpen: boolean
}

interface Methods {
  extract: (
    key: string | undefined,
    option: Option | undefined,
  ) => string | undefined
  extractKey: (item: Option) => string
  extractLabel: (item: Option | undefined) => string
  handleSetOpen: (isOpen: boolean) => void
  handleSelect: (item: Option) => void
}

interface Computed {
  listStyle: Partial<CSSStyleDeclaration>
}

interface Props {
  list: Option[]
  value: Option
  placeholder: string
  keyExtractor: string | ((option: Option) => string)
  labelExtractor: string | ((option: Option | undefined) => string)
  fallbackExtractor?: (option: Option) => boolean
  lightTheme: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ToggleArrow,
    CustomSelectOption,
  },
  props: {
    list: {
      default: () => [],
    },
    value: {
      default: () => undefined,
    },
    placeholder: {
      default: () => '',
    },
    keyExtractor: {
      default: () => '',
    },
    labelExtractor: {
      default: () => '',
    },
    fallbackExtractor: {
      default: () => undefined,
    },
    lightTheme: {
      default: () => false,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    listStyle(): Partial<CSSStyleDeclaration> {
      const { $el } = (this.$refs.popoverElement as Vue) || {}
      return {
        width: !this.isOpen && !$el ? 'auto' : `${$el.clientWidth}px`,
      }
    },
  },
  methods: {
    extract(key?: string, option?: Option): string | never {
      if (typeof option !== 'object') {
        return String(option)
      }

      return key && option ? option[key as keyof object] : ''
    },
    extractKey(option: Option): string {
      const text =
        typeof this.keyExtractor === 'function'
          ? this.keyExtractor(option)
          : this.extract(this.keyExtractor, option)
      return `option-${text}`
    },
    extractLabel(option: Option | undefined): string {
      const text =
        typeof this.labelExtractor === 'function'
          ? this.labelExtractor(option)
          : this.extract(this.labelExtractor, option)
      return text || this.placeholder
    },
    handleSelect(item) {
      if (this.fallbackExtractor?.(item)) {
        return this.$emit('fallback')
      }
      this.$emit('input', item)
    },
    handleSetOpen(isOpen: boolean): void {
      this.isOpen = isOpen
    },
  },
})
